<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="panel-body">
    <div class="use-description">
      <div>■セルモン倉庫へ納品依頼登録を行った情報が表示されます。</div>
      <div>■納品依頼登録を行って頂いた後、「納品ラベル」、「商品ラベル」が表示できるようになるまで数営業日のお時間を頂く場合があります。 ラベルが準備出来次第メールでご連絡いたします。</div>
      <div>■納品の流れ</div>
      <div class="pd-l-30">①[セルモン画面] 納品依頼登録　→　②ラベル準備完了のメールを受信　→　③[セルモン画面] 納品ラベル、商品ラベルの印刷　→　④商品の発送（納品）　→　⑤[セルモン画面] 発送情報の登録</div>
    </div>
    <div class="box-btn-delivery-register m-t-sm">
      <button type="button" class="btn btn-primary btn-delivery-register pd-l-30 pd-r-30" @click.prevent="clickRegisterNew()">新規登録</button>
    </div>
    <div class="list-wrapper pd-l-20 m-t-sm">
      <div id="form-delivery-search" class="form-inline m-b">
        <div class="form-group">
          <label>納品管理番号</label>
          <input type="text" v-model.trim="deliveryNo" class="form-control delivery-no" name="delivery-no">
        </div>
        <div class="form-group">
          <label>ASIN</label>
          <input type="text" v-model.trim="deliveryAsin" class="form-control asin" name="asin">
        </div>
        <div class="form-group">
          <label>納品予定日</label>
          <date-picker
            v-model="deliveryDate"
            placeholder=""
            ref="datepickerStart"
            format="YYYY/MM/DD"
            :input-attr="{id: 'delivery-date'}"
            :lang="lang"
          ></date-picker>
        </div>
        <div class="mr-t-15">
          <button type="button" class="btn btn-primary m-r-sm" @click.prevent="onHandleSearch()">検索</button>
          <button type="button" class="btn btn-basic" @click.prevent="clearInputSearch()">クリア</button>
        </div>
      </div>
      <div class="table-wrapper">
        <table id="delivery-list-table" class="table table-bordered">
          <thead>
            <tr>
              <th class="w-110"></th>
              <th class="w-120">納品ラベル印刷</th>
              <th class="w-120">商品ラベル印刷</th>
              <th class="w-120">発送情報</th>
              <th class="head-delivery-no">納品管理番号</th>
              <th class="head-delivery-name">納品名</th>
              <th class="w-120">納品予定日</th>
              <th class="w-120">作成日</th>
              <th class="w-150"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!initial && !this.pageData.length">
              <td colspan="9" class="bg-danger text-danger text-center font-bold">データが見つかりません。</td>
            </tr>
            <template v-else v-for="(data, index) in pageData">
              <tr :key="`start-empty-rows-${index}`" class="empty-rows">
                <td colspan="9"></td>
              </tr>
              <tr :key="`delivery-${index}`" :class="`delivery-item delivery-item-${data.deliveryNo}`" @click="handleClickRow(data)">
                <td>
                  <div class="btn-collapse btn-collapse-open">
                    <i class="fa fa-plus collapse-icon"></i> <span class="collapse-text">開く</span>
                  </div>
                </td>
                <td>
                  <button v-if="data.isDeliveryPdfEnable" type="button" class="btn btn-primary btn-delivery-label" @click.prevent="getDeliveryLabelPdf(data, 'deliveryLabelPdf')">納品ラベル印刷</button>
                  <button v-else type="button" class="btn btn-basic btn-delivery-label" disabled="true">納品ラベル準備中</button>
                </td>
                <td>
                  <button v-if="data.isGoodsPdfEnable" type="button" class="btn btn-primary btn-product-label" @click.prevent="getDeliveryLabelPdf(data, 'goodsLabelPdf')">商品ラベル印刷</button>
                  <button v-else type="button" class="btn btn-basic btn-product-label" disabled="true">商品ラベル準備中</button>
                </td>
                <td>
                  <delivery-register-info-bubble
                    :key="`info-bubble-${data.deliveryNo}`"
                    :delivery="data"
                    @registerSuccess="handleRegisterInfoSuccess"
                    :isFirstInfo="index === 0"
                    :isLastInfo="index === (pageData.length - 1)"
                  />
                </td>
                <td>
                  <div class="data-delivery-no cursor-auto">
                    {{ data.deliveryNo }}
                  </div>
                </td>
                <td>
                  <div class="data-delivery-name cursor-auto">
                    {{ data.deliveryName }}
                  </div>
                </td>
                <td>
                  <div class="data-delivery-date cursor-auto">
                    {{ data.deliveryDate }}
                  </div>
                </td>
                <td>
                  <div class="data-create-date cursor-auto">
                    {{ data.createDate }}
                  </div>
                </td>
                <td>
                  <div class="box-action">
                    <button v-if="data.isEditEnable" type="button" class="btn btn-primary m-r-xs btn-edit-delivery" @click.prevent="clickUpdateButton(data)">編集</button>
                    <button v-else type="button" class="btn btn-basic m-r-xs" disabled="true">編集</button>

                    <button v-if="data.isDeleteEnable" type="button" class="btn btn-delete-delivery" @click.prevent="openConfirmDeleteDeliveryModal(data)">削除</button>
                    <button v-else type="button" class="btn btn-basic" disabled="true">削除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="data.goods.length" :key="`collapse-delivery-${index}`" :class="`collapse-delivery-${data.deliveryNo} collapse`">
                <td colspan="9" class="p-0">
                  <div :class="`box-delivery-product-${data.deliveryNo} p-xs`">
                    <div style="background-color: #fff; padding: 0 4px;">
                      <table :class="`table table-bordered delivery-product-list-table`">
                        <thead>
                          <tr>
                            <th class="w-120" style="text-align: center;">納品する商品</th>
                            <th></th>
                            <th class="w-120" style="text-align: right; border: none; padding-right: 25px;">納品予定数</th>
                            <th class="w-220" style="border: none;">商品ラベル</th>
                            <th class="w-180" style="border: none;">商品ラベル貼付</th>
                            <th class="w-130" style="border: none;">有効期限</th>
                            <th class="w-180" style="border: none;">出荷時の梱包</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(product, productIndex) in data.goods">
                            <tr :key="`product-${productIndex}`" class="data-rows">
                              <td class="text-center">
                                <div class="box-selected-product-image w-40">
                                  <img :src="product.image" alt="" class="selected-product-image img-responsive">
                                </div>
                                <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(product.status)}`">{{ product.status_str }}</div>
                              </td>
                              <td>
                                <div class="m-b-xs">{{ product.itemName }}</div>
                                <div>{{ product.asin }}</div>
                              </td>
                              <td class="text-right" style="padding-right: 25px;">{{ product.quantity }}</td>
                              <td>
                                <div class="box-delivery-product-barcode w-160">
                                  <img src="/static/dists/img/delivery_product_barcode.png" class="img-responsive">
                                </div>
                                <div v-if="product.fnskuKbn">{{ product.fnsku }}</div>
                                <div v-else>{{ product.goodsCode }}</div>
                              </td>
                              <td>
                                <div :class="[!parseInt(product.goodsLabelAttachKbn) ? 'text-gray' : '']">{{ product.goodsLabelAttachKbnStr }}</div>
                              </td>
                              <td>
                                <div v-if="product.dueDateManageFlg">{{ product.expirationDate }}</div>
                                <div v-else class="text-gray">なし</div>
                              </td>
                              <td>
                                <div :class="[!product.packingSettingKbn || !parseInt(product.packingSettingKbn) ? 'text-gray' : '']">{{ product.packingSettingKbnStr }}</div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <pagination
      :url="`/Deliveries`"
      :filters="this.filters"
      :maxRows="300"
      :clientMode="true"
      :needLoading="true"
      @onChangePage="onChangePage"
      ref="pagination"
    />
    <modal-confirm-delete-delivery
      v-if="openModalConfirmDeleteDelivery"
      @confirm="deleteDelivery()"
      @close="closeConfirmDeleteDeliveryModal()"
    />
 </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import DeliveryRegisterInfoBubble from '@/view/deliveryRequests/components/DeliveryRegisterInfoBubble'
import Pagination from '@/view/deliveryRequests/components/DeliveryRequestsPagination'
import LoadingBlock from '@/components/LoadingBlock'
import moment from 'moment'
import ModalConfirmDeleteDelivery from '@/components/ModalDeleteAlert'
import DeliveryService from '@/services/deliveryservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    DatePicker,
    DeliveryRegisterInfoBubble,
    Pagination,
    LoadingBlock,
    ModalConfirmDeleteDelivery
  },
  data () {
    return {
      deliveryNo: '',
      deliveryAsin: '',
      deliveryDate: '',
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      defaultData: [],
      pageData: [],
      initial: true,
      filters: {
        deliveryNo: '',
        deliveryAsin: '',
        deliveryDate: ''
      },
      loader: null,
      openModalConfirmDeleteDelivery: false,
      selectedDelivery: null
    }
  },
  methods: {
    getJudgmentStatusClass (judgmentStatusCode) {
      let classes = ''
      let statusSuccess = ['2']
      let statusWarning = ['0', '1']
      let statusDanger = ['8', '9']
      if (statusSuccess.includes(judgmentStatusCode)) {
        classes = 'judgment-status-success'
      } else if (statusWarning.includes(judgmentStatusCode)) {
        classes = 'judgment-status-warning'
      } else if (statusDanger.includes(judgmentStatusCode)) {
        classes = 'judgment-status-danger'
      }
      return classes
    },
    clickRegisterNew () {
      this.$router.push({name: 'Delivery Requests', params: {tab: 'delivery-request-registration'}})
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_list_tab.click_register_new_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    clickUpdateButton (deliveryRequest) {
      this.$router.push({
        name: 'Delivery Requests',
        params: {tab: 'update-delivery-request-registration'},
        query: {deliveryNo: deliveryRequest.deliveryNo}
      })
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_list_tab.click_update_button,
        properties: {
          deliveryNo: deliveryRequest.deliveryNo
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleClickRow (delivery) {
      if (!Object.keys(delivery).length) {
        return false
      }
      let notAvailableSelectorClasses = ['btn-delivery-label', 'btn-product-label', 'box-delivery-info', 'data-delivery-no', 'data-delivery-name', 'data-delivery-date', 'data-create-date', 'box-action', 'shipping-info', 'btn-edit-delivery', 'btn-delete-delivery']
      let hasCollapse = true
      for (let i = 0; i < notAvailableSelectorClasses.length; i++) {
        if (event.target.className.includes(notAvailableSelectorClasses[i])) {
          hasCollapse = false
          break
        }
      }
      if (hasCollapse) {
        let deliveryNo = delivery.deliveryNo
        let collapseDeliverySelector = $(`.collapse-delivery-${deliveryNo}`)
        let deliveryItemSelector = $(`.delivery-item-${deliveryNo}`)
        collapseDeliverySelector.collapse('toggle')
        let btnCollapseSelector = $(`.delivery-item-${deliveryNo} .btn-collapse`)
        let btnCollapseIconSelector = $(`.delivery-item-${deliveryNo} .btn-collapse .collapse-icon`)
        let btnCollapseTextSelector = $(`.delivery-item-${deliveryNo} .btn-collapse .collapse-text`)
        let deliveryProductSelector = $(`.delivery-item-${deliveryNo}`)
        collapseDeliverySelector.on('shown.bs.collapse', () => {
          btnCollapseSelector.removeClass('btn-collapse-open')
          btnCollapseSelector.addClass('btn-collapse-close')
          btnCollapseIconSelector.removeClass('fa-plus')
          btnCollapseIconSelector.addClass('fa-minus')
          btnCollapseTextSelector.text('閉じる')
          deliveryProductSelector.addClass('collapse-expanding')
          $(`.box-delivery-product-${deliveryNo}`).addClass('box-delivery-product-list-table')
          deliveryItemSelector.css('border-bottom', '0')
          collapseDeliverySelector.css('border-top', '0')
        })
        collapseDeliverySelector.on('hidden.bs.collapse', () => {
          btnCollapseSelector.removeClass('btn-collapse-close')
          btnCollapseSelector.addClass('btn-collapse-open')
          btnCollapseIconSelector.addClass('fa-plus')
          btnCollapseIconSelector.removeClass('fa-minus')
          btnCollapseTextSelector.text('開く')
          deliveryProductSelector.removeClass('collapse-expanding')
          $(`.box-delivery-product-${deliveryNo}`).removeClass('box-delivery-product-list-table')
          deliveryItemSelector.css('border-bottom', '1px solid #ddd')
          collapseDeliverySelector.css('border-top', '1px solid #ddd')
        })
      }
    },
    onChangePage (data, needClear, keepSort, newData) {
      this.defaultData = [...data]
      this.pageData = newData && newData.length > 0 ? [
        ...this.pageData,
        ...newData
      ] : [...data]
      if (this.initial) {
        this.initial = false
      }
    },
    onHandleSearch () {
      this.filters.deliveryNo = this.deliveryNo
      this.filters.deliveryAsin = this.deliveryAsin
      this.filters.deliveryDate = this.formatDate(this.deliveryDate)

      let logParams = {
        name: eventCode.delivery_requests.delivery_request_list_tab.click_search_button,
        properties: this.filters
      }
      EventService.postTrackLog(logParams)
    },
    clearInputSearch () {
      this.deliveryNo = ''
      this.deliveryAsin = ''
      this.deliveryDate = ''
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    openConfirmDeleteDeliveryModal (data) {
      this.selectedDelivery = data
      this.openModalConfirmDeleteDelivery = true
    },
    closeConfirmDeleteDeliveryModal () {
      this.selectedDelivery = null
      this.openModalConfirmDeleteDelivery = false
      $('#delete-alert').modal('hide')
    },
    deleteDelivery () {
      if (!this.selectedDelivery) {
        return
      }
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: this.selectedDelivery.deliveryNo
      }
      DeliveryService.destroyRequest(params)
        .then((response) => {
          this.$refs.pagination.handleData(this.selectedDelivery, 'delete')
          this.closeConfirmDeleteDeliveryModal()
          this.loader && this.loader.hide()
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })

      let logParams = {
        name: eventCode.delivery_requests.delivery_request_list_tab.click_delete_button,
        properties: params
      }
      EventService.postTrackLog(logParams)
    },
    handleRegisterInfoSuccess (delivery) {
      this.$refs.pagination.handleData(delivery, 'update')
    },
    getDeliveryLabelPdf (data, pdfType) {
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: data.deliveryNo,
        pdfType: pdfType
      }
      DeliveryService.getLabelPdf(params)
        .then((response) => {
          const file = new Blob([response], {type: 'application/pdf'})
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL)
          this.loader && this.loader.hide()
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })

      let code = eventCode.delivery_requests.delivery_request_list_tab.click_delivery_label_print_button
      if (pdfType === 'goodsLabelPdf') {
        code = eventCode.delivery_requests.delivery_request_list_tab.click_product_label_print_button
      }
      let logParams = {
        name: code,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    formatGoodsCodeByAsin (asin) {
      let goodsCode = `${this.$store.getters.getUser.sellerId.replaceAll('SSC-', '')}-${asin}-00`
      return goodsCode
    }
  },
  watch: {
    $route (routeValue) {
      let isDeliveryRequestsPage = routeValue.name === 'Delivery Requests' ? 1 : 0
      let isDeliveryRequestsTabList = routeValue.params.tab === 'delivery-request-list' ? 1 : 0
      let hasActionRefresh = routeValue.query.action && routeValue.query.action === 'refresh' ? 1 : 0
      if (isDeliveryRequestsPage && isDeliveryRequestsTabList && hasActionRefresh) {
        this.$refs.pagination.reload(true)

        let btnCollapseCloseSelector = $('#delivery-list-table .btn-collapse-close')
        let collapseSelector = $('#delivery-list-table .collapse')
        let btnCollapseIconSelector = $(`#delivery-list-table .btn-collapse-close .collapse-icon`)
        let btnCollapseTextSelector = $(`#delivery-list-table .btn-collapse-close .collapse-text`)
        let deliveryProductSelector = $(`#delivery-list-table .delivery-item`)

        btnCollapseIconSelector.addClass('fa-plus')
        btnCollapseIconSelector.removeClass('fa-minus')
        btnCollapseTextSelector.text('開く')
        btnCollapseCloseSelector.removeClass('btn-collapse-close')
        btnCollapseCloseSelector.addClass('btn-collapse-open')
        collapseSelector.removeClass('in')
        deliveryProductSelector.removeClass('collapse-expanding')

        let logParams = {
          name: eventCode.delivery_requests.delivery_request_list_tab.show,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'delivery-request-list') {
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_list_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>

<style>
.content {
  overflow: unset;
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/DeliveryRequestList.vue